// @owners { team: patients }
import { getBrand } from '@alto/design-system';
import { Experimentation } from '@alto/experimentation';
import { useEffect } from 'react';
import { getCompanyFullName, getCompanyName } from '~shared/config/getCompanyName';
import { faviconURLByDomain, updateFaviconLinks } from '~web/hooks/favicons';

const addMetaTags = (appName: string) => {
  const appNameMetaTag = document.createElement('meta');
  appNameMetaTag.setAttribute('name', 'application-name');
  appNameMetaTag.setAttribute('content', appName);
  document.head.appendChild(appNameMetaTag);

  const mobileWebAppTitleMetaTag = document.createElement('meta');
  mobileWebAppTitleMetaTag.setAttribute('name', 'apple-mobile-web-app-title');
  mobileWebAppTitleMetaTag.setAttribute('content', appName);
  document.head.appendChild(mobileWebAppTitleMetaTag);
};

/**
 * Sets the favicon and title for the browser tab based on the current domain
 */
export const useBrowserTab = () => {
  const currentHostName = window.location.hostname;
  const { isLoading: isExperimentationLoading } = Experimentation.useFeatureFlag('fuze_brand_override', false);

  useEffect(() => {
    if (isExperimentationLoading) return;

    switch (true) {
      case currentHostName.includes('patientrxauth'):
        updateFaviconLinks({ faviconURL: faviconURLByDomain['patientrxauth'] });
        document.title = 'Patient support program';
        break;
      // Brand rather than hostname, so the icon follows the FuzeRx cutover without a second change.
      case getBrand() !== 'alto':
        updateFaviconLinks({ faviconURL: faviconURLByDomain[getBrand() === 'fuzerx' ? 'fuzerx' : 'fuzehealth'] });
        // TODO: When we clean up the 'fuze_brand_override' flag, move this to apps/web/src/template.ejs
        document.title = `${getCompanyFullName()} | Get your prescriptions delivered`;
        addMetaTags(getCompanyName());
        break;
      default:
        addMetaTags(getCompanyName());
        break;
    }
  }, [currentHostName, isExperimentationLoading]);
};
